export function ImgChats({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 511.998 511.998"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path d="M414.584,11.114H230.977c-53.789,0-97.414,43.625-97.414,97.414v13.891H97.414C43.625,122.418,0,166.043,0,219.832v92.538
            c0,57.693,27.524,99.439,80.206,99.439h8.838v66.783c0,23.929,32.597,31.005,42.518,9.23c7.525-16.516,20.194-32.173,36.671-46.55
            c10.344-9.026,21.517-16.972,32.683-23.713c4.002-2.416,7.419-4.338,10.068-5.749h56.146c55.155,0,111.304-46.393,111.304-99.439
            v-11.865h53.357c52.682,0,80.206-41.747,80.206-99.439v-92.538C511.998,54.732,468.388,11.114,414.584,11.114z M267.13,367.288
            h-61.44c-3.269,0-6.498,0.72-9.457,2.109c-3.922,1.84-10.296,5.199-18.327,10.047c-13.253,8-26.498,17.421-38.944,28.281
            c-1.833,1.599-3.632,3.215-5.397,4.849v-23.025c0-12.294-9.967-22.261-22.261-22.261H80.206
            c-23.245,0-35.684-18.867-35.684-54.918v-92.538c0-29.2,23.692-52.892,52.892-52.892h58.41h125.195
            c1.441,0,2.863,0.074,4.275,0.187c21.836,1.749,39.946,16.759,46.24,36.978c1.545,4.968,2.377,10.25,2.377,15.726v58.413
            c0,0.029,0.002,0.058,0.002,0.087v34.039C333.913,338.75,299.374,367.288,267.13,367.288z M467.476,201.066
            c0,36.05-12.439,54.918-35.684,54.918h-53.357v-36.152c0-10.549-1.685-20.704-4.788-30.219
            c-12.079-37.046-45.757-64.33-86.17-66.976c-2.135-0.14-4.286-0.218-6.456-0.218h-0.002H178.085v-13.891
            c0-29.2,23.692-52.892,52.892-52.892h183.608c29.213,0,52.892,23.683,52.892,52.892V201.066z" />
        </g>
      </g>
    </svg>
  );
}